export default __webpack_public_path__ + "static/damper_w.a8201c0e7c02d73051c63da2e67fc209.svg";